const preventEnterKeySubmission = (e: React.KeyboardEvent<HTMLFormElement>): void => {
    const { target } = e;
    if (e.key === 'Enter' && target instanceof HTMLInputElement) {
        e.preventDefault();
    }
};

export default preventEnterKeySubmission;
